import axios from 'axios';
const base = 'hashtag';

function getAll(query = null) {
    return axios.get(base, {
        params: query
    });
}

function register(data) {
    return axios.post(base, data);
}

function update(data) {
    return axios.put([base, data.id_htag].join('/'), data);
}

function destroy(id) {
    return axios.delete([base, id].join('/'));
}

const HashTagService = {
    getAll: getAll,
    register: register,
    update: update,
    destroy: destroy
};
export default HashTagService;
